import './media-control.scss';
class MediaControl {
    constructor (element, options) {
        // Defaults & Settings
        const defaults = {
            initAttr: 'data-root'
        };

        this.settings = Object.assign({}, defaults, options);

        // Elements
        this.$root = element;
    }

    /**
     * Initializes the media control component:
     * - Sets click event listener on the root element
     * - Prepares the component to dispatch 'media_control.change' events
     */
    initialize () {
        this.setEvents();
    }

    /**
     * Sets click event listener on the media control button:
     * - Toggles the `aria-pressed` state
     * - Dispatches a 'media_control.change' event with the new pressed state
     */
    setEvents () {
        this.$root.addEventListener('click', () => {
            const pressed = this.$root.getAttribute('aria-pressed') === 'true';

            this.$root.setAttribute('aria-pressed', !pressed);

            this.$root.dispatchEvent(new CustomEvent('media_control.change', {
                detail: { pressed: !pressed },
                bubbles: true
            }));
        });
    }
}

export { MediaControl };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-mediacontrol]');
        $$roots.forEach($root => {
            const $rootAPI = new MediaControl($root);
            $rootAPI.initialize();
        });
    }
});
